import { ANSWER_MODE_SOURCES_ENDPOINT } from 'api/constants';
import { api } from 'store/api/api';

import type { GetSourcesResponse } from 'modules/shared/api/sources.api.types';

// The optional `previewingVisibilityGroup` tells the BE to treat a curator
// as a consumer for the duration of a view-as preview — passed as a query
// param so the call stays a CORS-simple request (custom headers would
// trigger preflight against traefik's allowlist). Making it part of the
// query arg also gives the cache key a natural per-preview bucket so
// switching in/out of view-as refetches the right surface.
type GetAnswerModeSourcesArg = {
  previewingVisibilityGroup?: number | null;
};

const answerSourcesApi = api
  .enhanceEndpoints({
    addTagTypes: ['AnswerModeSources'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAnswerModeSources: builder.query<
        GetSourcesResponse,
        GetAnswerModeSourcesArg | void
      >({
        query: (arg) => {
          const previewingVisibilityGroup =
            arg && 'previewingVisibilityGroup' in arg
              ? arg.previewingVisibilityGroup
              : undefined;
          return {
            url: ANSWER_MODE_SOURCES_ENDPOINT,
            method: 'GET',
            credentials: 'include',
            ...(previewingVisibilityGroup != null && {
              params: {
                previewing_visibility_group: previewingVisibilityGroup,
              },
            }),
          };
        },
        providesTags: ['AnswerModeSources'],
        keepUnusedDataFor: 1800, // 30 minute cache - sources don't change frequently
      }),
    }),
  });

export const { useGetAnswerModeSourcesQuery } = answerSourcesApi;
